const navbar = {
  packages: "패키지", // translated 
  hotelPackages: "호텔 패키지", // translated 
  experiences: "경험담", // translated 
  close: "닫다", // translated 
  hotDeals: "특가 상품", // translated 
  dashboard: "계기반", // translated 
  pricing: "가격", // translated 
};


export default navbar;
